module.exports = __webpack_public_path__ + "img/5-1@2x.ed3d4e49.png";